module.exports = __webpack_public_path__ + "static/media/process-one.1cbbe9d7.svg";